module.exports = __webpack_public_path__ + "static/media/residencial02.4c2e134f.jpg";